import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { listCandidates } from "@/services/candidatesApi";
import { UserSearch } from "lucide-react";

export function CandidatesStatCard() {
  const navigate = useNavigate();
  const [total, setTotal] = useState<number | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await listCandidates(navigate, { page: 1, size: 1 });
        setTotal(res.total);
      } catch {
        setTotal(null);
      } finally {
        setLoading(false);
      }
    })();
  }, [navigate]);

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium">Candidats</CardTitle>
        <UserSearch className="h-4 w-4 text-muted-foreground" />
      </CardHeader>
      <CardContent>
        {loading ? (
          <div className="text-sm text-muted-foreground">Chargement...</div>
        ) : total !== null ? (
          <div className="text-2xl font-bold">{total.toLocaleString("fr-FR")}</div>
        ) : (
          <div className="text-sm text-red-600">Erreur</div>
        )}
      </CardContent>
    </Card>
  );
}
